import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API, useAuth } from "@/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav("/login"); return; }
      const sid = decodeURIComponent(m[1]);
      try {
        await axios.post(`${API}/auth/session`, { session_id: sid });
        await refresh();
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login");
      }
    })();
  }, [nav, refresh]);

  return (
    <main className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-zinc-500">Confirming…</div>
    </main>
  );
}
